const EMPTY_ICON_RULES = [
  [/chargeback/, 'money_off'],
  [/refund/, 'undo'],
  [/withdrawal/, 'account_balance_wallet'],
  [/anticipation/, 'trending_up'],
  [/commission/, 'percent'],
  [/pay-by-link/, 'link'],
  [/billing|invoice|payment|statement|arrangement/, 'payments'],
  [/voucher/, 'confirmation_number'],
  [/webhook|integration/, 'webhook'],
  [/email/, 'email'],
  [/ticket|support|faq|sla|followup|concierge/, 'support_agent'],
  [/schedule|calendar/, 'event'],
  [/notification|alert/, 'notifications'],
  [/shipment|carrier|logistic/, 'local_shipping'],
  [/enrollment|tuition|student|school/, 'school'],
  [/form/, 'assignment'],
  [/offer/, 'local_offer'],
  [/review/, 'rate_review'],
  [/order|basket|cart/, 'shopping_cart'],
  [/price|catalog/, 'sell'],
  [/stock|product|inventory|variant|option|range/, 'inventory_2'],
  [/media|image|appearance/, 'image'],
  [/partnership/, 'handshake'],
  [/task/, 'task_alt'],
  [/activit/, 'history'],
  [/point|referral|redemption/, 'stars'],
  [/sign|envelope|policy|document/, 'description'],
  [/user|customer|profile|contact|signer|people/, 'people'],
  [/channel|site|page|menu/, 'language'],
  [/categor|tag|brand|group|class/, 'label'],
  [/featured/, 'star'],
];

export const resolveListingEmptyIcon = tableId => {
  const id = String(tableId || '');
  const match = EMPTY_ICON_RULES.find(([pattern]) => pattern.test(id));

  return match ? match[1] : 'search_off';
};
